<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      unit="发货通知单"
      id-key="DeliveryDocId"
      :data="data"
      :line-form="true"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      :save-func="()=>{}"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="isMB?24:12">
              <el-form-item label="订单编号">
                <span class="detail-span">{{data.OrderNo}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="isMB?24:12">
              <el-form-item label="通知单号">
                <span class="detail-span">{{data.TradeUnitNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="客户名称">
                <span class="detail-span">{{data.FullName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="提交人">
                <span class="detail-span">
                  <span>{{data.Person}}</span>
                  <span v-if="data.Phone">/{{data.Phone}}</span>
                  <span v-if="data.Address">/{{data.Address}}</span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="isMB?24:12">
              <el-form-item label="提交时间">
                <span class="detail-span">{{$commonJs.toDateString(data.DeliveryDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="发货方式">
                <span class="detail-span">{{data.EmpName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
         <el-divider><i class="el-icon-mobile-phone"></i></el-divider>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>产品信息</span>
        </div>
        <el-table class="table-line tb-c-head" :data="data.Products" border>
          <el-table-column label="产品名称" prop="ProductName" min-width="150" />
          <el-table-column label="产品规格" prop="ProductSpec" min-width="90" />
          <el-table-column label="可发货数量" prop="DeliveryQuantity" min-width="120" />
          <el-table-column label="本次发货数量" prop="Quantity" min-width="120" />
        </el-table>
        <div style="margin-top: 10px;">
          <el-form-item label="备注" label-width="50px">
            <span class="detail-span">{{data.Remark}}</span>
          </el-form-item>
        </div>
      </template>
      <template slot="footer">
        <template v-if="isReview">
          <el-button :loading="isLoading" type="success" @click="review">通 过</el-button>
          <el-button :loading="isLoading" type="danger" @click="back">退 回</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import Elselect from "../../../../common/trendsTable/common/components/elselect.vue";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    Elselect
},
  data() {
    return {
      api: require("@/api/sa/deliveryDoc").default,
      data: {
        DeliveryDocId: 0,
        DeliveryDocNo: "",
        OrderId: 0,
        OrderNo: "",
        TradeUnitNo: "",
        FullName: "",
        Person: "",
        Phone: "",
        Address: "",
        DeliveryDate: this.$commonJs.getToday(), //发货日期

        EmpId: null, //经办人Id
        EmpName: "",
        Remark: "",
        Status: 0,
        Products: [],
      },
      isReview: false,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {},
  methods: {
    onEditOpened(data) {
      this.isReview = true;
      console.log("onEditOpened", data);
    },
    review() {
      this.$refs.dialog.isLoading = true;
      this.isLoading = true;
      this.api.review(this.data.DeliveryDocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    back() {
      this.$refs.dialog.isLoading = true;
      this.isLoading = true;
      this.api.back(this.data.DeliveryDocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.data.Products = [];
      this.isReview = false;
    },
  },
};
</script>